/**
 * Navbar - Top Navigation Bar
 * 
 * Spans full width at the top of the application.
 * Includes mobile hamburger menu to toggle sidebar.
 */

import { Menu } from 'lucide-react';
import { UserDropdown } from './UserDropdown';
import { CompanySelector } from './CompanySelector';
import { NotificationBell } from './NotificationBell';
import { ModuleSwitcher } from './ModuleSwitcher';
import { useMobileMenu } from '@/context/MobileMenuContext';

export function Navbar() {
  const { toggleMobileMenu } = useMobileMenu();

  return (
    <header className="sticky top-0 z-50 h-16 bg-white border-b border-gray-200 flex items-center w-full">
      <div className="flex items-center justify-between px-6 w-full">
        {/* Left: Module Switcher + Company Selector */}
        <div className="flex items-center gap-3">
          <ModuleSwitcher />
          <div className="h-8 w-px bg-gray-300 hidden md:block" />
          <div className="hidden md:block">
            <CompanySelector />
          </div>
        </div>

        {/* Right: Mobile Menu Button + Notifications + User */}
        <div className="flex items-center gap-2">
          {/* Mobile Hamburger Menu - visible on mobile, hidden on desktop */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Toggle sidebar"
          >
            <Menu className="w-6 h-6 text-gray-700" />
          </button>
          
          <NotificationBell />
          <UserDropdown />
        </div>
      </div>
    </header>
  );
}
